import { spapiAuthApi, } from '@sellsen/generated-sources';
import { useMutation, useQuery } from '@tanstack/react-query';
const QUERY_KEYS = {
    all: ['spapi-auth'],
    getAmazonRedirectUri: (params) => [
        ...QUERY_KEYS.all,
        params,
    ],
    checkAuthorizationStatus: () => [...QUERY_KEYS.all, 'check-authorization'],
};
export const useGetAmazonRedirectUriQuery = (params) => {
    return useQuery({
        queryKey: QUERY_KEYS.getAmazonRedirectUri(params),
        queryFn: () => {
            return spapiAuthApi.getAmazonRedirectUri(params);
        },
    });
};
export const useCheckAuthorizationStatusQuery = () => {
    return useQuery({
        queryKey: QUERY_KEYS.checkAuthorizationStatus(),
        queryFn: () => {
            return spapiAuthApi.checkAuthorizationStatus();
        },
    });
};
export const useGetAuthCallbackMutation = () => {
    return useMutation({
        mutationFn: (params) => spapiAuthApi.handleCallback(params),
    });
};
